import { createContext } from "react";
import { StartFlowResponse } from "src/services/link/commands/NetTypes";
import { AppThemeType, ConnectedEntity } from "src/types/apps";

import { initial, State } from "./store";

export interface Actions {
	setStep: (val: number) => void;
	onSelectEntity: (val: ConnectedEntity) => void;
	onStartFlow: (val: StartFlowResponse) => void;
	onProductError: () => void;
	onErrorMessage: (message: string) => void;
}

export interface ContextType {
	id: string;
	isFrame?: boolean;
	themeType: string;
	subproduct?: string;
	product: string;
	theme?: AppThemeType;
	state: State;
	actions: Actions;
}

const defaultContextValues: ContextType = {
	id: "",
	themeType: "light",
	subproduct: "",
	product: "",
	state: initial,
	actions: {
		setStep: () => {},
		onSelectEntity: () => {},
		onStartFlow: () => {},
		onProductError: () => {},
		onErrorMessage: () => {}
	}
};

export default createContext<ContextType>(defaultContextValues);
